import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { getIconNameForCampaignType, getTitleForCampaignType } from '../../service/CampaignHelpers/CampaignHelpers';
import { CampaignType } from '../../typings/domain';
import { Shape2, Shape2Theme } from '../Shape2/Shape2';

type GridCampaignTypeCellProps = {
    type: CampaignType;
};

export class GridCampaignTypeCell extends React.Component<GridCampaignTypeCellProps> {
    render() {
        const { type } = this.props;

        return (
            <Shape2
                cls={Bem.cls('grid-type-cell', 'icon')}
                theme={Shape2Theme.light}
                icon={getIconNameForCampaignType(type)}
                width={16}
                height={16}
                title={getTitleForCampaignType(type)}
            />
        );
    }
}
